<template>
    <b-form @submit.prevent="openModalConfirmAnggota">
        <div class="parameter-section-card mb-4">
            <h6 class="parameter-card-title">Maksimum Gadai per Tipe Pinjaman</h6>
            <p class="parameter-card-subtitle">Jumlah maksimum unit gadai berjalan per anggota untuk tiap tipe pinjaman aktif.</p>

            <div class="table-responsive">
                <table class="table parameter-matrix-table mb-0">
                    <thead>
                        <tr>
                            <th style="width: 50%;">TIPE PINJAMAN</th>
                            <th style="width: 50%;">MAKSIMUM GADAI</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="localJenisPinjamanList.length === 0">
                            <td colspan="2" class="text-center py-3 text-muted">Memuat data tipe pinjaman...</td>
                        </tr>
                        <tr v-for="(item, idx) in localJenisPinjamanList" :key="idx">
                            <td class="align-middle">
                                <div class="font-weight-bold text-dark">{{ item.jenisPinjamanName }}</div>
                                <span class="badge-kode-subtle" v-if="item.jenisPinjamanKode">{{ item.jenisPinjamanKode }}</span>
                            </td>
                            <td class="align-middle">
                                <b-input-group append="unit" class="input-group-custom" style="max-width: 260px;">
                                    <b-form-input v-model="item.maxGadaiNominal" type="number" class="form-control-custom text-right" required></b-form-input>
                                </b-input-group>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Global Parameter Anggota Grid (2 Columns) -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    MAKSIMUM GADAI PER JENIS <i class="fa fa-info-circle text-muted ml-1" id="tip-max-jenis"></i>
                    <b-popover target="tip-max-jenis" triggers="hover focus" placement="top">
                        Jumlah maksimum jenis barang pada transaksi gadai berjalan per anggota.
                    </b-popover>
                </label>
                <b-input-group append="jenis" class="input-group-custom">
                    <b-form-input v-model="anggotaInput.MAX_GADAI_JENIS" type="number" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    MAKSIMUM PERPANJANGAN GADAI <i class="fa fa-info-circle text-muted ml-1" id="tip-max-perpanjangan"></i>
                    <b-popover target="tip-max-perpanjangan" triggers="hover focus" placement="top">
                        Batas maksimum kali perpanjangan gadai sebelum otomatis rollover/tutup dan terbit SBG baru.
                    </b-popover>
                </label>
                <b-input-group append="kali" class="input-group-custom">
                    <b-form-input v-model="anggotaInput.MAX_PERPANJANGAN" type="number" min="1" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    BONUS GADAI PERTAMA <i class="fa fa-info-circle text-muted ml-1" id="tip-bonus-pertama"></i>
                    <b-popover target="tip-bonus-pertama" triggers="hover focus" placement="top">
                        Nominal tambahan plafon yang diberikan khusus untuk penggadaian pertama kali nasabah.
                    </b-popover>
                </label>
                <b-input-group append="Rp." class="input-group-custom">
                    <b-form-input v-model="anggotaInput.BONUS_GADAI_PERTAMA" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>

            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    PERSENTASE STATUS MACET <i class="fa fa-info-circle text-muted ml-1" id="tip-macet"></i>
                    <b-popover target="tip-macet" triggers="hover focus" placement="top">
                        Adjustment persentase pinjaman untuk anggota dengan status riwayat macet (contoh: 60%).
                    </b-popover>
                </label>
                <b-input-group append="%" class="input-group-custom">
                    <b-form-input v-model="anggotaInput.ADJUST_MACET" type="number" step="0.01" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    PERSENTASE STATUS KURANG LANCAR <i class="fa fa-info-circle text-muted ml-1" id="tip-kurang-lancar"></i>
                    <b-popover target="tip-kurang-lancar" triggers="hover focus" placement="top">
                        Adjustment persentase pinjaman untuk anggota dengan status riwayat kurang lancar (contoh: 80%).
                    </b-popover>
                </label>
                <b-input-group append="%" class="input-group-custom">
                    <b-form-input v-model="anggotaInput.ADJUST_KURANG_LANCAR" type="number" step="0.01" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>

            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    PERSENTASE STATUS LANCAR <i class="fa fa-info-circle text-muted ml-1" id="tip-lancar"></i>
                    <b-popover target="tip-lancar" triggers="hover focus" placement="top">
                        Adjustment persentase pinjaman untuk anggota dengan status riwayat lancar (contoh: 110%).
                    </b-popover>
                </label>
                <b-input-group append="%" class="input-group-custom">
                    <b-form-input v-model="anggotaInput.ADJUST_LANCAR" type="number" step="0.01" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    PERSENTASE ANGGOTA BARU <i class="fa fa-info-circle text-muted ml-1" id="tip-baru"></i>
                    <b-popover target="tip-baru" triggers="hover focus" placement="top">
                        Adjustment persentase pinjaman untuk anggota baru belum memiliki riwayat (contoh: 100%).
                    </b-popover>
                </label>
                <b-input-group append="%" class="input-group-custom">
                    <b-form-input v-model="anggotaInput.ADJUST_BARU" type="number" step="0.01" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>

            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    HITUNGAN HARI MACET <i class="fa fa-info-circle text-muted ml-1" id="tip-hari-macet"></i>
                    <b-popover target="tip-hari-macet" triggers="hover focus" placement="top">
                        Batas hari keterlambatan pembayaran yang dikategorikan sebagai macet.
                    </b-popover>
                </label>
                <b-input-group append="hari" class="input-group-custom">
                    <b-form-input v-model="anggotaInput.HARI_MACET" type="number" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    HITUNGAN HARI KURANG LANCAR <i class="fa fa-info-circle text-muted ml-1" id="tip-hari-kurang-lancar"></i>
                    <b-popover target="tip-hari-kurang-lancar" triggers="hover focus" placement="top">
                        Batas hari keterlambatan pembayaran yang dikategorikan sebagai kurang lancar.
                    </b-popover>
                </label>
                <b-input-group append="hari" class="input-group-custom">
                    <b-form-input v-model="anggotaInput.HARI_KURANG_LANCAR" type="number" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
            <button type="submit" class="btn btn-save-primary" :disabled="isSubmitting">
                <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
                {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
            </button>
        </div>

        <ModalConfirm 
            id="modal-confirm-anggota" 
            title="Konfirmasi Perubahan Parameter Anggota" 
            :isSubmitting="isSubmitting" 
            desc="Apakah anda yakin ingin menyimpan perubahan parameter anggota ini?" 
            @submit="onSubmit" 
        />
    </b-form>
</template>

<script>
export default {
    name: 'anggota',
    props: {
        anggotaInput: { type: Object, required: true },
        jenisPinjamanList: { type: Array, default: () => [] },
        wilayahId: { type: [Number, String], default: null }
    },
    data() {
        return {
            isSubmitting: false,
            localJenisPinjamanList: []
        }
    },
    watch: {
        jenisPinjamanList: {
            handler(newVal) {
                this.localJenisPinjamanList = JSON.parse(JSON.stringify(newVal || []))
            },
            immediate: true,
            deep: true
        },
        "anggotaInput.BONUS_GADAI_PERTAMA": function(newValue) {
            if (!newValue) return
            const result = String(newValue).replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.anggotaInput.BONUS_GADAI_PERTAMA = result)
        }
    },
    methods: {
        openModalConfirmAnggota() {
            this.$bvModal.show("modal-confirm-anggota")
        },

        async onSubmit() {
            this.isSubmitting = true
            try {
                // 1. Update Max Gadai per Tipe Pinjaman
                if (this.wilayahId && this.localJenisPinjamanList.length > 0) {
                    for (let item of this.localJenisPinjamanList) {
                        let payload = new FormData()
                        payload.append("wilayahId", this.wilayahId)
                        payload.append("jenisPinjamanId", item.jenisPinjamanId)
                        payload.append("bungaTenor1", item.bungaTenor1 || 0)
                        payload.append("bungaTenor2", item.bungaTenor2 || 0)
                        payload.append("admAwalPersen", item.admAwalPersen || 0)
                        payload.append("admAwalNominalMin", item.admAwalNominalMin || 0)
                        payload.append("admBulananPersen", item.admBulananPersen || 0)
                        payload.append("admBulananNominalMin", item.admBulananNominalMin || 0)
                        payload.append("dendaHarianPersen", item.dendaHarianPersen || 0)
                        payload.append("maxGadaiNominal", item.maxGadaiNominal || 0)

                        await this.$axios.post("parameter/update-jenis-pinjaman", payload)
                    }
                }

                // 2. Update Global Anggota Parameters
                let globalPayload = new FormData()
                const cleanedData = {
                    MAX_GADAI_JENIS: this.anggotaInput.MAX_GADAI_JENIS,
                    MAX_PERPANJANGAN: this.anggotaInput.MAX_PERPANJANGAN || 4,
                    BONUS_GADAI_PERTAMA: this.$helper.removeThousandSeparator(this.anggotaInput.BONUS_GADAI_PERTAMA),
                    ADJUST_MACET: this.anggotaInput.ADJUST_MACET,
                    ADJUST_KURANG_LANCAR: this.anggotaInput.ADJUST_KURANG_LANCAR,
                    ADJUST_LANCAR: this.anggotaInput.ADJUST_LANCAR,
                    ADJUST_BARU: this.anggotaInput.ADJUST_BARU,
                    HARI_MACET: this.anggotaInput.HARI_MACET,
                    HARI_KURANG_LANCAR: this.anggotaInput.HARI_KURANG_LANCAR
                }

                for (let [k, v] of Object.entries(cleanedData)) {
                    globalPayload.append("name", k)
                    globalPayload.append("value", v)
                }

                await this.$axios.post("parameter/update", globalPayload)

                this.$helper.toastSucc(this, "Parameter Anggota berhasil disimpan!")
                this.$bvModal.hide("modal-confirm-anggota")
                this.$emit("refresh")
            } catch (err) {
                this.$helper.parseError(this, err)
            } finally {
                this.isSubmitting = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.parameter-section-card {
    background-color: #fafdfc;
    border: 1px solid #e2ece7;
    border-radius: 10px;
    padding: 20px 24px;
}

.parameter-card-title {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 2px;
}

.parameter-card-subtitle {
    font-size: 12.5px;
    color: #64748b;
    margin-bottom: 16px;
}

.parameter-matrix-table {
    thead th {
        background-color: transparent;
        color: #64748b;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        border-top: none;
        border-bottom: 1px solid #e2ece7;
        padding: 10px 12px;
    }

    tbody td {
        padding: 12px;
        border-top: 1px solid #edf4f1;
        border-bottom: none;
    }
}

.badge-kode-subtle {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 600;
    text-transform: uppercase;
}

.param-grid-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: #475569;
    text-transform: uppercase;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
}

.form-control-custom {
    border-radius: 8px !important;
    border: 1px solid #d8e2dc !important;
    font-size: 13px !important;
    height: 38px !important;
    color: #1e293b !important;

    &:focus {
        border-color: #0b3b36 !important;
        box-shadow: 0 0 0 2px rgba(11, 59, 54, 0.12) !important;
    }
}

.input-group-custom {
    ::v-deep .input-group-text {
        background-color: #f8fafc;
        border-color: #d8e2dc;
        font-size: 12.5px;
        font-weight: 600;
        color: #64748b;
        border-radius: 0 8px 8px 0;
    }
}

.btn-save-primary {
    background-color: #0b3b36;
    color: #ffffff;
    border: 1px solid #0b3b36;
    border-radius: 8px;
    padding: 9px 32px;
    font-size: 13.5px;
    font-weight: 700;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: #082d29;
        border-color: #082d29;
        box-shadow: 0 2px 8px rgba(11, 59, 54, 0.2);
    }
}
</style>
